export const dummyNavLinks = [
  {
    title: "Buy a watch",
    subcategories: [
      {
        name: "Brands",
        links: [
          { label: "Rolex", url: "/explore-brands?name=Rolex" },
          {
            label: "Audemars Piguet",
            url: "/explore-brands?name=Audemars Piguet",
          },
          {
            label: "Patek Philippe",
            url: "/explore-brands?name=Patek Philippe",
          },

          { label: "Richard Mille", url: "/explore-brands?name=Richard Mille" },
          // { label: "Breitling", url: "/explore-brands?name=Breitling" },
          // { label: "Cartier", url: "/explore-brands?name=Cartier" },
          // { label: "IWC", url: "/explore-brands?name=IWC" },
          // {
          //   label: "Jaeger-LeCoultre",
          //   url: "/explore-brands?name=Jaeger-LeCoultre",
          // },
          // { label: "Hublot", url: "/explore-brands?name=Hublot" },
          // {
          //   label: "Vacheron Constantin",
          //   url: "/explore-brands?name=Vacheron Constantin",
          // },
          // {
          //   label: "A. Lange & Söhne",
          //   url: "/explore-brands?name=A. Lange & Söhne",
          // },
          // { label: "Breguet", url: "/explore-brands?name=Breguet" },
          // { label: "Hamilton", url: "/explore-brands?name=Hamilton" },
          // { label: "Oris", url: "/explore-brands?name=Oris" },
          // { label: "Omega", url: "/explore-brands?name=Omega" },

          // { label: "Tudor", url: "/explore-brands?name=Tudor" },
          // { label: "Panerai", url: "/explore-brands?name=Panerai" },
          // { label: "Seiko", url: "/explore-brands?name=Seiko" },
          // { label: "TAG Heuer", url: "/explore-brands?name=TAG Heuer" },
          // { label: "Zenith", url: "/explore-brands?name=Zenith" },
          // { label: "Longines", url: "/explore-brands?name=Longines" },
          // { label: "Ulysse Nardin", url: "/explore-brands?name=Ulysse Nardin" },
          // { label: "NOMOS", url: "/explore-brands?name=NOMOS" },
          // { label: "Sinn", url: "/explore-brands?name=Sinn" },
          { label: "View all", url: "/brands" },
        ],
      },
      // {
      //   name: "Categories",
      //   links: [
      //     {
      //       label: "Men's Watches / Women's Watches",
      //       url: "/categories?name=mens-womens-watches",
      //     },
      //     {
      //       label: "New Watches / Pre-Owned Watches",
      //       url: "/categories?name=new-pre-owned-watches",
      //     },
      //     {
      //       label: "Mechanical Watches / Automatic Watches",
      //       url: "/categories?name=mechanical-automatic-watches",
      //     },
      //     { label: "Vintage Watches", url: "/categories?name=vintage-watches" },
      //     { label: "Chronographs", url: "/categories?name=chronographs" },
      //     { label: "Diving Watches", url: "/categories?name=diving-watches" },
      //     { label: "Pilot's Watches", url: "/categories?name=pilots-watches" },
      //     {
      //       label: "Military Watches",
      //       url: "/categories?name=military-watches",
      //     },
      //     { label: "Swiss Watches", url: "/categories?name=swiss-watches" },
      //     {
      //       label: "Affordable Watches",
      //       url: "/categories?name=affordable-watches",
      //     },
      //     {
      //       label: "Popular watches - Daily updated",
      //       url: "/categories?name=popular-watches",
      //     },
      //     {
      //       label: "Bracelets and Straps / Parts and Accessories",
      //       url: "/categories?name=bracelets-straps-parts-accessories",
      //     },
      //     { label: "Display all", url: "/categories" },
      //   ],
      // },
      // {
      //   name: "Services",
      //   links: [
      //     // { label: "Watch Collection", url: "/services/watch-collection" },
      //     { label: "Free Watch Valuation", url: "/services/valuation" },
      //     // { label: "Advanced Search", url: "/services/advanced-search" },
      //   ],
      // },
    ],
  },
  {
    title: "Sell a watch",
    subcategories: [
      // {
      //   name: "What Is Your Watch Worth?",
      //   description:
      //     "Have it appraised now and sell it for the best possible price.",
      //   links: [{ label: "Free ", url: "/sell/private-seller" }],
      // },
      {
        name: "As a Professional Supplier",
        description:
          "Unlock the opportunity to showcase your watches to hundreds of thousands of enthusiasts daily.",
        links: [
          {
            label: "Create Listing",
            url: "/user/create-listing",
          },
        ],
      },
      // {
      //   name: "Free Watch Valuation",
      //   // description:
      //   //   "Have it appraised now and sell it for the best possible price.",
      //   links: [
      //     {
      //       label: "What is your watch worth?",
      //       url: "/services/valuation",
      //     },
      //   ],
      //   image:
      //     "https://cdn.discordapp.com/attachments/920721313105080390/1305573370745720973/Group_9.png?ex=67338573&is=673233f3&hm=49bc36497a55456276097e59c02289ecd287b88de11fbeb5ae6fe6206ef8473e&", // Path to image for Free Watch Valuation
      // },
    ],
  },
  // {
  //   title: "Magazine",
  //   url: "/magazine",
  // },
  {
    title: "Supplier",
    url: "/supplier",
  },
  // {
  //   title: "ChronoPulse",
  //   url: "/chronopulse",
  // },
  // {
  //   title: "FAQ",
  //   url: "/faqs",
  // },
  // {
  //   title: "Security",
  //   subcategories: [
  //     {
  //       name: "Learn more",
  //       links: [
  //         { label: "Buyer Protection", url: "/security/buyer-protection" },
  //         { label: "Trusted Checkout", url: "/security/trusted-checkout" },
  //       ],
  //     },
  //   ],
  // },
];
